import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";

import styles from "./WorkShopsSeminars.module.css";

const WorkshopsSeminars = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "workshopSeminars",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        title: "",
        organizer: "",
        category: "",
        year: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      {fields.map((item, idx) => (
        <div className={styles.grid4} key={item.id}>
          <Input
            label="Title"
            name={`workshopSeminars[${idx}].title`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Organizer"
            name={`workshopSeminars[${idx}].organizer`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Event Type"
            name={`workshopSeminars[${idx}].category`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Year/Duration"
            name={`workshopSeminars[${idx}].year`}
            register={register}
            errors={errors}
            duration
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}
      <div className={styles.buttonOuter}>
        <div></div>

        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                title: "",
                organizer: "",
                category: "",
                year: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default WorkshopsSeminars;
